module.exports = __webpack_public_path__ + "img/24.4e5d1b5b.jpg";